goog.provide("shadow.js.shim.module$react_use$lib$useTimeout");
goog.provide("module$shadow_js_shim_module$react_use$lib$useTimeout");
shadow.js.shim.module$react_use$lib$useTimeout = shadow.js.nativeProvides["react-use/lib/useTimeout"] = shadow$bridge("react-use/lib/useTimeout");
module$shadow_js_shim_module$react_use$lib$useTimeout.default = shadow.js.shim.module$react_use$lib$useTimeout;
